export const profile = {
  name: "Jerald Pamugas",
  title:
    "Senior Full Stack Software Engineer specializing in enterprise applications, business process automation, and digital transformation.",
  subheadline:
    "6+ years delivering production systems for global organizations, from requirements discovery through deployment and long-term support.",
  location: "Philippines",
  experienceYears: "6+ years",
  currentCompany: "JPMorganChase",
  previousCompany: "Teradyne Philippines, Myvan Holdings",
  availability: "Available for Remote Contract and Freelance Work",
  rate: "$30-$60/hour",
  email: "jeraldpamugas11@gmail.com",
  phone: "+63 920-6349-724",
  linkedin: "https://ph.linkedin.com/in/jerald-pamugas",
  github: "https://github.com/jeraldpamugas",
  resumeUrl: require("@/assets/Jerald_Pamugas.pdf"),
  scheduleCallUrl:
    "mailto:jeraldpamugas11@gmail.com?subject=Schedule%20a%20Call%20-%20Project%20Inquiry"
};

export const navLinks = [
  { label: "Why Work With Me", id: "why-work-with-me" },
  { label: "Services", id: "services" },
  { label: "Core Expertise", id: "core-expertise" },
  { label: "Case Studies", id: "case-studies" },
  { label: "Experience", id: "experience" },
  { label: "Process", id: "process" },
  { label: "FAQ", id: "faq" },
  { label: "Contact", id: "contact" }
];

export const differentiators = [
  {
    title: "Enterprise Experience",
    description:
      "Built and supported enterprise applications used by global organizations with strict quality standards."
  },
  {
    title: "End-to-End Development",
    description:
      "From requirements discovery to architecture, development, testing, deployment, and production support."
  },
  {
    title: "Business Focus",
    description:
      "I design solutions around business workflows, risk reduction, and maintainable long-term operations."
  },
  {
    title: "Long-Term Partnership",
    description:
      "Clean architecture, maintainable code, and professional communication for teams planning long-term growth."
  }
];

export const expertiseGroups = [
  {
    title: "Backend",
    items: ["ASP.NET Core", "C#", "REST APIs", "Entity Framework", "SQL Server"]
  },
  {
    title: "Frontend",
    items: ["Vue.js", "React", "JavaScript", "TypeScript", "HTML", "CSS"]
  },
  {
    title: "Automation",
    items: ["Python", "Playwright", "UiPath"]
  },
  {
    title: "Cloud and Dev Tools",
    items: ["Git", "Azure", "Firebase", "AWS (Learning)", "Docker (Learning)"]
  }
];

export const caseStudies = [
  {
    slug: "enterprise-farm-operations-platform",
    title: "Enterprise Farm Operations Management Platform",
    overview:
      "Production platform used by a real harvesting operation with around 18 workers and 30 to 50 farms each season.",
    summary:
      "Digitized payroll, scheduling, billing, and worker workflows while aligning with real field operations.",
    businessChallenge:
      "The business handled payroll computation, worker scheduling, billing, cash advances, and farm tracking with fragmented manual records. Attendance still depended on field-based manual logging, which could not be replaced abruptly.",
    solution:
      "I designed and built a web and mobile platform that centralizes worker management, payroll, billing, scheduling, farm monitoring, and reports. Payroll is fully automated. Attendance remains operationally manual, while the architecture is prepared for future digital attendance workflows.",
    responsibilities: [
      "Requirements gathering with business users and operators",
      "Solution architecture and database design",
      "Backend and REST API implementation",
      "Frontend web and mobile application development",
      "Testing, deployment, and production support"
    ],
    architecture: {
      frontend: "Vue (Web) and Ionic (Mobile)",
      api: "ASP.NET Core REST API with JWT authentication",
      database: "SQL Server with Entity Framework Core"
    },
    technology: ["ASP.NET Core", "Entity Framework Core", "SQL Server", "JWT Authentication", "Vue", "Ionic"],
    outcome: [
      "Centralized operational records in a single system",
      "Automated payroll computation and reporting workflows",
      "Created a scalable base for future digital attendance integration"
    ],
    lessonsLearned: [
      "Operational reality should shape rollout strategy, not just technical preference.",
      "Designing for gradual adoption improves trust and long-term platform usage."
    ],
    futureEnhancements: [
      "Digital attendance capture with offline-first workflows",
      "Deeper analytics for seasonal workforce planning"
    ],
    screenshots: [
      {
        src: require("@/assets/img/system/Thresher-mobile/img1.jpg"),
        alt: "Farm operations mobile application home screen"
      },
      {
        src: require("@/assets/img/system/Thresher-mobile/img2.jpg"),
        alt: "Farm operations mobile workflow screen"
      },
      {
        src: require("@/assets/img/system/Thresher-mobile/img3.jpg"),
        alt: "Farm operations mobile management interface"
      },
      {
        src: require("@/assets/img/system/Thresher-mobile/img4.jpg"),
        alt: "Farm operations mobile reporting screen"
      }
    ],
    githubUrl: null,
    liveDemoUrl: null
  },
  {
    slug: "kineticore-gym-app",
    title: "KinetiCore",
    overview:
      "KinetiCore is a cross-platform mobile application built to simplify workout planning and fitness tracking while providing a scalable foundation for future feature expansion.",
    summary:
      "Cross-Platform Fitness and Workout Companion designed for intuitive training management and cloud-connected progress tracking.",
    businessChallenge:
      "Many fitness users struggle to consistently organize workout routines and track long-term progress. Existing apps often become either too complex for daily use or too limited for structured training. The objective was to build a clean, user-friendly mobile experience with strong scalability.",
    solution:
      "KinetiCore delivers a streamlined mobile experience with simple navigation, cloud-based synchronization, and a maintainable architecture. The platform is designed for reliable daily usage while keeping the backend structure flexible for future fitness and personalization features.",
    responsibilities: [
      "Product planning and feature definition",
      "UI and UX implementation",
      "Cross-platform mobile development",
      "Backend integration and Firebase configuration",
      "Authentication and database structure design",
      "Testing, deployment preparation, and application maintenance"
    ],
    architecture: {
      frontend: "React Native mobile interface",
      api: "Cloud-connected application layer with Firebase services",
      database: "Cloud Firestore data model with Firebase Storage support"
    },
    technology: [
      "Mobile: React Native",
      "Cloud Platform: Firebase Authentication, Cloud Firestore, Firebase Storage",
      "Programming: JavaScript",
      "Development Tools: Git, GitHub"
    ],
    keyFeatures: [
      "Workout Routine Management",
      "Exercise Tracking",
      "Progress Monitoring",
      "Cloud Synchronization",
      "User Authentication",
      "Responsive Mobile Interface",
      "Scalable Architecture"
    ],
    engineeringHighlights: [
      "Cross-platform application development from planning through deployment",
      "Cloud-native mobile architecture using Firebase services",
      "Authentication and data structure implementation for production-ready workflows",
      "Maintainable code organization for future feature expansion",
      "User-focused interface design with practical mobile navigation"
    ],
    outcome: [
      "Established a production-ready cross-platform fitness application foundation",
      "Delivered a clean and consistent mobile experience for workout and progress workflows",
      "Demonstrated end-to-end ownership across product, engineering, and release preparation"
    ],
    lessonsLearned: [
      "Building mobile products requires balancing clean UX with scalable architecture decisions.",
      "Early structure in data modeling improves maintainability and feature extensibility.",
      "Cloud integration strategy significantly affects reliability and long-term development speed."
    ],
    futureEnhancements: [
      "Advanced workout analytics and progress visualization",
      "AI-assisted workout recommendations",
      "Wearable device integration",
      "Community and social accountability features",
      "Enhanced personalization and adaptive training plans"
    ],
    screenshots: [
      {
        src: require("@/assets/img/system/KinetiCore/img1.png"),
        alt: "KinetiCore mobile application screen 1"
      },
      {
        src: require("@/assets/img/system/KinetiCore/img2.png"),
        alt: "KinetiCore mobile application screen 2"
      },
      {
        src: require("@/assets/img/system/KinetiCore/img3.png"),
        alt: "KinetiCore mobile application screen 3"
      },
      {
        src: require("@/assets/img/system/KinetiCore/img4.png"),
        alt: "KinetiCore mobile application screen 4"
      },
      {
        src: require("@/assets/img/system/KinetiCore/img5.png"),
        alt: "KinetiCore mobile application screen 5"
      }
    ],
    githubUrl: null,
    liveDemoUrl: null
  },
  {
    slug: "enterprise-automation-solutions",
    title: "Enterprise Automation and Internal Platforms",
    overview:
      "Designed and delivered multiple enterprise applications and automation solutions for global business operations.",
    summary:
      "Built internal platforms and automation workflows that improved consistency, traceability, and delivery speed across global operations.",
    businessChallenge:
      "Global business teams needed reliable internal systems and workflow automation to reduce repetitive manual handling while maintaining operational controls.",
    solution:
      "Led solution design and implementation for enterprise ticketing, career progression, onboarding instructions, workflow assignment platforms, and automation tools. Delivered reusable development standards and frameworks to accelerate future internal projects.",
    responsibilities: [
      "Direct stakeholder communication and requirements clarification",
      "Architecture decisions and implementation planning",
      "Backend and frontend delivery across internal platforms",
      "Business process automation using Python, Playwright, and UiPath",
      "Testing, controlled deployment, and production support"
    ],
    architecture: {
      frontend: "Internal web interfaces for global business users",
      api: "Business workflow APIs and automation integrations",
      database: "Structured data models aligned to operational controls"
    },
    technology: ["Python", "Playwright", "UiPath", "REST APIs", "Internal Platform Development"],
    outcome: [
      "Improved workflow consistency across internal operations",
      "Enabled reusable development patterns for faster delivery",
      "Strengthened collaboration between engineering and business stakeholders"
    ],
    lessonsLearned: [
      "Reusable frameworks accelerate delivery only when paired with clear standards.",
      "Early stakeholder alignment reduces rework in enterprise workflows."
    ],
    futureEnhancements: [
      "Expand reusable frameworks for broader internal platform coverage"
    ],
    screenshots: [
      {
        src: require("@/assets/img/web-application.png"),
        alt: "Enterprise internal platform illustration placeholder"
      }
    ],
    githubUrl: null,
    liveDemoUrl: null
  },
  {
    slug: "legacy-enterprise-modernization",
    title: "Legacy Enterprise Modernization",
    overview:
      "Part of an approximately ten-engineer team modernizing a legacy COBOL platform for global enterprise users.",
    summary:
      "Migrated a COBOL-based enterprise application into a modern ASP.NET MVC system while preserving critical business logic.",
    businessChallenge:
      "The legacy platform slowed change velocity and maintainability. Modernization had to preserve business continuity for global users while transitioning architecture and user workflows.",
    solution:
      "Delivered phased modernization from COBOL to ASP.NET MVC with careful validation of legacy rules, progressive rollout, and collaborative release planning.",
    responsibilities: [
      "Requirements gathering and clarification",
      "Database design and data mapping support",
      "Backend and frontend development contributions",
      "Testing and deployment execution"
    ],
    architecture: {
      frontend: "ASP.NET MVC web interface",
      api: "Application services for migrated workflows",
      database: "Relational data model aligned with legacy business rules"
    },
    technology: ["ASP.NET MVC", "C#", "SQL Server", "Legacy Migration", "Testing", "Deployment"],
    outcome: [
      "Completed modernization ahead of target schedule",
      "Improved maintainability for future enhancements",
      "Supported global users through transition with minimal disruption"
    ],
    lessonsLearned: [
      "Legacy modernization succeeds when business rules are validated early and continuously.",
      "Team coordination and phased rollout reduce migration risk in enterprise environments."
    ],
    futureEnhancements: [
      "Incremental architecture hardening and modernization of adjacent legacy modules"
    ],
    screenshots: [
      {
        src: require("@/assets/img/web-application.png"),
        alt: "Legacy modernization project interface illustration placeholder"
      }
    ],
    githubUrl: null,
    liveDemoUrl: null
  }
];

export const professionalExperience = [
  {
    company: "JPMorganChase",
    role: "Software Engineer",
    period: "Current",
    highlights: [
      "Designed and delivered multiple enterprise applications and automation solutions supporting global business operations.",
      "Projects include enterprise ticketing, career progression, onboarding instruction platforms, workflow assignment tools, and reusable development standards.",
      "Owned projects from requirements gathering and stakeholder communication to architecture decisions, delivery, deployment, and production support."
    ]
  },
  {
    company: "Teradyne Philippines",
    role: "Application Systems Analyst/Programmer",
    period: "Previous",
    highlights: [
      "Worked within a team of around ten developers modernizing a legacy COBOL enterprise application.",
      "Handled requirements gathering, database design, backend and frontend development, plus deployment activities.",
      "Supported a migration used by global users and completed ahead of the planned target schedule."
    ]
  },
  {
    company: "Myvan Holdings",
    role: "Full Stack Software Engineer",
    period: "Previous",
    highlights: [
      "Delivered business applications with ownership across planning, implementation, and rollout.",
      "Built maintainable systems that balanced operational needs with technical quality.",
      "Collaborated directly with stakeholders to turn business requirements into production-ready software."
    ]
  }
];

export const processSteps = [
  "Discovery",
  "Planning",
  "Architecture",
  "Development",
  "Testing",
  "Deployment",
  "Support"
];

export const services = [
  {
    title: "Enterprise Web Applications",
    description:
      "Design and deliver secure internal and customer-facing systems aligned with operational goals."
  },
  {
    title: "Business Process Automation",
    description:
      "Reduce repetitive manual workflows through reliable automation solutions and controlled rollouts."
  },
  {
    title: "REST API Development",
    description:
      "Build integration-ready APIs that support scalable products and internal business workflows."
  },
  {
    title: "Internal Business Systems",
    description:
      "Create operational tools for ticketing, assignment, onboarding, and cross-team execution."
  },
  {
    title: "Legacy System Modernization",
    description:
      "Migrate legacy applications to modern architecture while preserving critical business logic."
  },
  {
    title: "Database Design",
    description:
      "Design maintainable relational models that support accuracy, reporting, and long-term system growth."
  },
  {
    title: "System Integration",
    description:
      "Connect platforms and workflows to improve data flow and reduce operational friction."
  },
  {
    title: "Mobile Applications",
    description:
      "Build companion mobile workflows that extend operational systems into real-world field use."
  }
];

export const currentlyLearning = [
  "AWS",
  "Docker",
  "Kubernetes",
  "Advanced System Design"
];

export const faqItems = [
  {
    question: "Do you work with startups?",
    answer:
      "Yes. I work with startups that need strong ownership from requirements through production support."
  },
  {
    question: "Can you modernize existing applications?",
    answer:
      "Yes. Legacy modernization is one of my core strengths, including enterprise migration work."
  },
  {
    question: "Can you work with existing codebases?",
    answer:
      "Yes. I can audit, stabilize, extend, and refactor existing systems with minimal disruption."
  },
  {
    question: "Do you build APIs?",
    answer:
      "Yes. I design and implement REST APIs for web, mobile, and internal business platforms."
  },
  {
    question: "Do you work with international clients?",
    answer:
      "Yes. I support distributed teams across the US, Australia, Singapore, Canada, and Europe."
  },
  {
    question: "What is your timezone?",
    answer:
      "I am based in the Philippines (PHT) and coordinate overlapping schedules for international teams."
  },
  {
    question: "How do projects usually start?",
    answer:
      "Most projects start with a discovery call, followed by scope clarification, architecture planning, and a delivery roadmap."
  },
  {
    question: "How do you communicate during delivery?",
    answer:
      "I provide concise progress updates, documented decisions, and proactive risk communication throughout delivery."
  },
  {
    question: "What engagement models are available?",
    answer:
      "I am open to freelance, contract, and long-term remote engagements, including fixed-price enterprise projects."
  },
  {
    question: "Can you support projects after launch?",
    answer:
      "Yes. I provide long-term support, maintenance, and iterative improvements after deployment."
  }
];

export const testimonials = [
  {
    name: "Enterprise Client Placeholder",
    role: "Engineering Manager",
    quote:
      "LinkedIn recommendation placeholder: concise feedback about delivery quality, communication, and ownership."
  },
  {
    name: "Startup Client Placeholder",
    role: "CTO",
    quote:
      "LinkedIn recommendation placeholder: measurable impact on speed, reliability, and collaboration."
  }
];
